import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Col } from "reactstrap";
import EmployerGroupTable from "../../../Components/Tables/EmployerGroupTable/EmployerGroupTable";
import { useDispatch } from "react-redux";
import { getRolesForTables } from "../../../slices/admin/thunk";
import Loading from "../../../Components/Loading";
import { DASHBOARD_USER_ROLES } from "../../../constants";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import DropdownActionsTable from "../../../Components/Dropdown/DropdownActionsTable";
import { downloadEmployersReportByUserId } from "../../../slices/general/thunk";
import { useCurrentUser } from "../../../slices/auth/hooks";

const DashboardEmployersGA = ({ isLoaded, employerId }) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const isNational = currentUser?.role === DASHBOARD_USER_ROLES.NATIONAL;
  const isAdmin = currentUser?.role === DASHBOARD_USER_ROLES.ADMIN;
  const { id } = useParams();

  const [isTerminated, setIsTerminated] = useState(false);

  const [loading, setLoading] = useState(false);

  const [employers, setEmployers] = useState([]);
  const [totalEmployers, setTotalEmployers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchEmployers = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: employerId || id,
          userRole: DASHBOARD_USER_ROLES.GA,
          role: "employers",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployers(response.data);
      setTotalEmployers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoaded) {
      if (debouncedSearchTerm === lastSearchTerm) {
        setSearchDone(true);
      } else {
        setSearchDone(false);
      }
      fetchEmployers();
    }
  }, [
    isTerminated,
    employerId,
    debouncedSearchTerm,
    id,
    dispatch,
    currentPage,
  ]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      <Container fluid>
        <div
          style={{ paddingTop: "3px" }}
          className="col-12 d-flex justify-content-between mt-4 mb-3 align-items-center "
        >
          <div className="col-4 d-flex justify-content-end align-items-center">
            <SearchBar
              inputRef={inputRef}
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Filter by name or email"
            />
            {(isAdmin || isNational) && (
              <DropdownActionsTable
                downloadMethod={downloadEmployersReportByUserId}
                params={{ dashboardUserId: employerId || id }}
              />
            )}
          </div>
        </div>

        <Col xl={12}>
          <div className="table-container  position-relative">
            {loading && <Loading />}
            <div className="live-preview">
              <div className="table-responsive ">
                <EmployerGroupTable
                  data={employers}
                  searchDone={searchDone}
                  searchParam={debouncedSearchTerm}
                  paginationProps={{
                    currentPage,
                    totalPages,
                    totalItems: totalEmployers,
                    pageSize,
                    onChangePage: handleChangePage,
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Container>

      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardEmployersGA;
